/**
 * Grants page application JS.
 */
import { ComponentManager } from 'js-component-framework';
import grants from 'components/grants';

const manager = new ComponentManager('knight-foundation-grants');

document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents([
    grants,
  ]);
});

if (module.hot) {
  module.hot.accept();
  manager.initComponents([
    grants,
  ]);
}

